// extracted by mini-css-extract-plugin
module.exports = {"container":"QrCode_container__2_O4g","whiteBox":"QrCode_whiteBox__1PzgI","qrCopyButton":"QrCode_qrCopyButton__3zTi3"};